
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BeneficiarioCriptomoneda } from 'src/app/dashboard/interfaces/beneficiario-criptomoneda.interface';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import Swal from 'sweetalert2';
import { DialogBeneficiarioCriptoComponent } from '../../dialog-beneficiario-cripto/dialog-beneficiario-cripto.component';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { RecipientCriptoService } from 'src/app/dashboard/services/recipient-cripto.service';
@Component({
  selector: 'app-recipient-cripto-card',
  templateUrl: './recipient-cripto-card.component.html',
  styleUrls: ['./recipient-cripto-card.component.sass']
})
export class RecipientCriptoCardComponent implements OnInit {
  @Input() cuenta: BeneficiarioCriptomoneda | undefined;
  @Output() deleteAccount: EventEmitter<any> = new EventEmitter();
  @Output() actualizarCuenta: EventEmitter<BeneficiarioCriptomoneda> = new EventEmitter();
  subscriptions: Subscription = new Subscription();
  public user: any;

  constructor(
    private accountRecipientService: RecipientCriptoService,
    private spinner: SpinnerService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private store: Store<AppState>) { }

  ngOnInit() {
    this.subscriptions.add(
      this.store.select('auth').subscribe(({ user }: any) => {
        this.user = user;
      })
    );
  }


  async verCuenta(){
    this.dialog.open(DialogBeneficiarioCriptoComponent, {
      data: this.cuenta,
      disableClose: true,
    });
  }


  async inactivarCuenta(){
    if( !(this.cuenta && this.cuenta.beneficiario_id))return;
    const resullt = await Swal.fire({
      title: '¿Está seguro de que desea desvincular esta cuenta?',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: `No`,
      confirmButtonColor: '#1e5a3f',
    });
    if(resullt.isDenied || !resullt.isConfirmed){
      return;
    }
    const spinnerRef  = this.spinner.start();
    try {
      await this.accountRecipientService.inactivateAccount(this.cuenta.beneficiario_id);
      this.snackBar.open('Cuenta eliminada correctamente', 'Ok', {
        duration: 3000
      });
      this.deleteAccount.emit();
    } catch (error) {
    }
    this.spinner.stop(spinnerRef);

  }

  actualizar(){
    this.actualizarCuenta.emit(this.cuenta);
  }
}
